<template>
  <div style="background-color: white">
    <div v-if="showPage" id="container">
      <dialog id="filters-modal">
        <svg @click="closeModal('filters-modal'); assignFilteringValues()" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h2>Filters</h2>
        <table class="input-table card-band-styling">
          <tbody>
            <tr>
              <th colspan="2">Search</th>
            </tr>
            <tr>
              <td>Free Search:</td>
              <td>
                <input type="text" v-model="inputObject.search_query">
              </td>
            </tr>
            <tr>
              <th colspan="2">Filtering</th>
            </tr>
            <tr class="range-row">
              <td>Age Range:</td>
              <td>
                <select v-model="inputObject.startAgeValue" id="startAge" class="ageGroup" @change="changeStartAgeRange">
                  <option value="All">All</option>
                  <option v-for="(item,index) in maxAgeRange" :key="index" :value="item">{{ item }}</option>
                </select>
                to
                <select v-model="inputObject.endAgeValue" id="endAge" class="ageGroup" @change="changeStartAgeRange">
                  <option value="All">All</option>
                  <option v-for="(item,index) in (inputObject.startAgeValue == 'All' ? maxAgeRange : maxAgeRange-parseInt(inputObject.startAgeValue)+1)" :key="index" :value="inputObject.startAgeValue == 'All' ? item : parseInt(inputObject.startAgeValue)+index">{{ inputObject.startAgeValue == 'All' ? item : parseInt(inputObject.startAgeValue)+index }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Classification:</td>
              <td>
                <select v-model="inputObject.classification">
                  <option value="All">All</option>
                  <option value="Assessment/Test">Assessment/Test</option>
                  <option value="Screening/Mini-Test">Screening/Mini-Test</option>
                  <option value="Intervention/Training/Lesson">Intervention/Training/Lesson</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Area:</td>
              <td>
                <select v-model="inputObject.area">
                  <option value="All">All</option>
                  <option :value="area" v-for="(area,index) in categorization.areas" :key="`${index}-areas`">
                    {{ area }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Type:</td>
              <td>
                <select v-model="inputObject.type">
                  <option value="All">All</option>
                  <option :value="type" v-for="(type,index) in categorization.types" :key="`${index}-types`">
                    {{ type }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Category:</td>
              <td>
                <select v-model="inputObject.category">
                  <option value="All">All</option>
                  <option :value="category" v-for="(category,index) in categorization.categories" :key="`${index}-categories`">
                    {{ category }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>sub_category:</td>
              <td>
                <select v-model="inputObject.sub_category">
                  <option value="All">All</option>
                  <option :value="sub_category" v-for="(sub_category,index) in categorization.sub_categories" :key="`${index}-sub_categories`">
                    {{ sub_category }}
                  </option>
                </select>
              </td>
            </tr>
            <tr class="range-row">
              <td>Period:</td>
              <td>
                <input type="date" id="startDate" @change="changeStartDate" v-model="inputObject.periodStart">
                to
                <input type="date" id="endDate" @change="changeStartDate" v-model="inputObject.periodEnd">
                <span class="tooltip-searchDate">
                  <font-awesome-icon :icon="['fas', 'circle-info']" style="vertical-align: middle; margin-left: 5px" />
                  <span class="tooltiptext-searchDate">
                    <table class="tooltip-table">
                      <tbody>
                        <tr>
                          <td>mm/dd/yyyy to mm/dd/yyyy:</td>
                          <td>All Dates</td>
                        </tr>
                        <tr>
                          <td>06/12/2015 to mm/dd/yyyy:</td>
                          <td>06/12/2015 to Present</td>
                        </tr>
                        <tr>
                          <td>mm/dd/yyyy to 06/12/2015:</td>
                          <td>Past to 06/12/2015</td>
                        </tr>
                      </tbody>
                    </table>
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center;">
                <button @click="newFilters">Search Filtering</button>
              </td>
            </tr>
          </tbody>
        </table>
      </dialog>
      <dialog v-if="deletionObject" id="delete-modal">
        <svg @click="closeModal('delete-modal')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h2>Delete Application</h2>
        <div class="delete-modal-box card-band-styling">
          To confirm deletion type out: "<strong>{{ deletionObject.title }}</strong>"
          <div style="text-align: center;">
            <input type="text" id="input-delete-modal-confirmation" :placeholder="deletionObject.title">
            <button @click="confirmDeletion(deletionObject)">Confirm Deletion</button>
          </div>
        </div>
      </dialog>
      <div class="function-buttons">
        <button style="margin-right: 5px;" @click="openModal('filters-modal')">Filters ({{ Object.keys(params).length }})</button>
        <button @click="newApp">New</button>
      </div>
      <div class="cards-format">
        <div v-for="(app, index) in applicationList" class="app-card card-band-styling" :key="index">
          <div>
            <div class="icon-row">
              <span>
  <!--               <span class="tooltip-icon" style="margin-right: 5px;">
                  <font-awesome-icon icon="fa-solid fa-clone" @click="cloneApp(app.application_id)" />
                  <span class="tooltiptext-icon">Clone</span>
                </span> -->
                <span class="tooltip-icon" style="margin-right: 5px;">
                  <font-awesome-icon icon="fa-solid fa-eye" @click="showPreviewModal(app)"/>
                  <span class="tooltiptext-icon">Preview</span>
                </span>
                <span class="tooltip-icon">
                  <font-awesome-icon :icon="['fas', 'pencil']" @click="editApp(app)"/>
                  <span class="tooltiptext-icon">Edit</span>
                </span>
              </span>
              <span class="tooltip-icon">
                <font-awesome-icon :icon="['far', 'trash-can']" @click="deleteApp(app)" />
                <span class="tooltiptext-icon">Delete</span>
              </span>
            </div>
            <div class="app-card-grid">
              <div class="app-card-title">{{ app.title }}</div>
              <div class="app-card-subtitle">{{ app.subtitle }}</div>
              <div class="app-card-image">
                <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script> 
  import instance from '../axios.js'; 

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        showPage: null,
        showChildView: false,
        params: null,
        applicationList: null,
        categorization: null,
        maxAgeRange: 100,
        inputObject: {
          search_query: '',
          startAgeValue: 'All',
          endAgeValue: 'All',
          classification: 'All',
          area: 'All',
          type: 'All',
          category: 'All',
          sub_category: 'All',
          periodStart: '',
          periodEnd: ''
        },
        deletionObject: null,
        previewArray: null,
        previewArrayIndex: 0
      }
    },
    async created() {
      try {
        this.assignFilteringValues();
        let response = await instance.get('/api/appAdmin/searchfilter', {
          params: {
            ...this.params,
            owner_uuid: this.$store.getters.getCurrentUser
          }
        });
        this.applicationList = response.data;
        let userCategorizationResponse = await instance.get(`/api/appAdmin/categorization/owner/${this.$store.getters.getCurrentUser}`);
        this.categorization = userCategorizationResponse.data;
        if (this.applicationList != null && this.applicationList.length > 0) {
          this.deletionObject = this.applicationList[0];
        }
        this.showPage = true;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      navButtons(direction) {
        if (direction == 'backward') {
          if (this.previewArrayIndex-1 >= 0) {
            this.previewArrayIndex -= 1;
          }
        } else if (direction == 'forward') {
          if (this.previewArrayIndex+1 < this.previewArray.length) {
            this.previewArrayIndex += 1;
          }
        }
      },
      formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          this.previewArray.forEach(question => {
            let currentQuestionInstance = question;
            let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);

            let newWidth = document.getElementById(elementID).offsetWidth;
            let newHeight = document.getElementById(elementID).offsetHeight;
            if (newWidth == originalWidth && newHeight == originalHeight) {
              return;
            }

            //[x,y] transform coordinates from original to new resolution
            let xTransform = newWidth / originalWidth;
            let yTransform = newHeight / originalHeight;

            for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
              currentQuestionInstance.child_buttons[i].x *= xTransform;
              currentQuestionInstance.child_buttons[i].y *= yTransform;
              currentQuestionInstance.child_buttons[i].height *= yTransform;
              currentQuestionInstance.child_buttons[i].width *= xTransform;
            }

            for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
              currentQuestionInstance.child_images[i].x *= xTransform;
              currentQuestionInstance.child_images[i].y *= yTransform;
              currentQuestionInstance.child_images[i].height *= yTransform;
              currentQuestionInstance.child_images[i].width *= xTransform;
            }

            currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
          })
        });
      },
      getImageFileSrc(fileObject) {
        if (fileObject != null) {
          return URL.createObjectURL(fileObject);
        }
        return null;
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      async showPreviewModal(app) {
        this.$router.push({
          path: `/appTester/${app.application_id}`
        })
      },
      assignFilteringValues() {
        this.params = this.getQueryParams();
        //parse query so search/filter can be used again with auto filled current data
        for (let key in this.params) {
          if (Object.hasOwnProperty.call(this.inputObject, key)) {
            this.inputObject[key] = this.params[key];
          }
          else if (key == 'age_group') {
            let ages = this.params['age_group'].split(',');
            this.inputObject.startAgeValue = ages[0];
            this.inputObject.endAgeValue = ages[1];
          }
          else if (key == 'created') {
            let dates = this.params['created'].split(',');
            this.inputObject.periodStart = dates[0] == 'All' ? '' : dates[0];
            this.inputObject.periodEnd = dates[1] == 'All' ? '' : dates[1];
          }
        }
      },
      changeStartDate() {
        let from = document.getElementById('startDate');
        let to = document.getElementById('endDate');
        if (from.value >= to.value && to.value !== '') {
          let temp = new Date(from.value);
          temp.setDate(temp.getDate());
          to.valueAsDate = temp;
        }
        to.min = from.value;
      },
      changeStartAgeRange() {
        let from = document.getElementById('startAge');
        let to = document.getElementById('endAge');
        if (from.value != 'All' && to.value != 'All') {
          if (parseInt(from.value) > parseInt(to.value)) {
            this.inputObject.endAgeValue = this.maxAgeRange;
          }
        }
      },
      getQueryParams() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
          params[key] = value;
        }
        return params;
      },
      newApp() {
        this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard`);
      },
      deleteApp(app) {
        this.deletionObject = app;
        this.openModal('delete-modal');
      },
      async confirmDeletion(app) {
        try {
          let confirmationString = document.getElementById("input-delete-modal-confirmation").value;
          if (app.title == confirmationString) {
            await instance.delete(`/api/appAdmin/${app.application_id}`);
            document.getElementById("input-delete-modal-confirmation").value = "";
            
            this.closeModal('delete-modal');
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: this.params
            });
            this.applicationList = response.data;
          }
          else {
            alert("confirmation string does not match")
          }
        } catch (e) {
          console.error(e);
        }
      },
      cloneApp(application_id) {
        this.$router.push({
          path: `/rolesPage/SearchAppAdminApps/viewAppAdminApps/cloneAppName`,
          query: {
            application_id
          }
        })
      },
      async newFilters() {
        try {
          let ageRangeResult = '';
          ageRangeResult += this.inputObject.startAgeValue;
          ageRangeResult += ',';
          ageRangeResult += this.inputObject.endAgeValue;

          let periodRangeResult = '';
          periodRangeResult += this.inputObject.periodStart == '' ? 'All' : this.inputObject.periodStart;
          periodRangeResult += ',';
          periodRangeResult += this.inputObject.periodEnd == '' ? 'All' : this.inputObject.periodEnd;

          const currentRoute = this.$route;
          const targetQuery = {
            ...(this.inputObject.search_query == '' ? {} : {search_query: this.inputObject.search_query}),
            ...(ageRangeResult == 'All,All' ? {} : {age_group: ageRangeResult}),
            ...(this.inputObject.classification == 'All' ? {} : {classification: this.inputObject.classification}),
            ...(this.inputObject.area == 'All' ? {} : {area: this.inputObject.area}),
            ...(this.inputObject.type == 'All' ? {} : {type: this.inputObject.type}),
            ...(this.inputObject.category == 'All' ? {} : {category: this.inputObject.category}),
            ...(this.inputObject.sub_category == 'All' ? {} : {sub_category: this.inputObject.sub_category}),
            ...(periodRangeResult == 'All,All' ? {} : {created: periodRangeResult})
          };
          const currentKeys = Object.keys(currentRoute.query);
          const targetKeys = Object.keys(targetQuery);
          const isSameKeys = currentKeys.length === targetKeys.length && currentKeys.every(key => targetKeys.includes(key));
          const isDifferentQuery = !isSameKeys || !currentKeys.every(key =>
            currentRoute.query[key] === targetQuery[key]
          );

          if (isDifferentQuery) {
            this.$router.replace({ query: targetQuery });
            this.assignFilteringValues();
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: {
                ...this.params,
                owner_uuid: this.$store.getters.getCurrentUser
              }
            });
            this.applicationList = response.data;
          }

        } catch (e) {
          console.error(e);
        }
      },
      editApp(app) {
        this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard/${app.application_id}`);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #container {
    font-family: 'Roboto', sans-serif;
    position: relative;
  }

  .cards-format {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;

    .app-card {
      $inner_padding: 16px;

      $card_width: 400px;
      $card_height: 300px;
      $inner_card_height: $card_height - (2 * $inner_padding);
      $inner_card_width: $card_width - (2 * $inner_padding);

      padding: $inner_padding;
      width: $card_width;
      height: $card_height;
      margin: 1rem;
      
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .icon-row {
        display: flex;
        justify-content: space-between;
      }

      .app-card-grid {
        display: grid;
        grid-template-rows: 31px 17px auto;
      }

      .app-card-title {
        font-size: 1.3rem;
        font-weight: 700;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .app-card-subtitle {
        font-size: .7rem;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .app-card-image {
        img {
          border-radius: 10px;
          width: $inner_card_width;
          height: 200px;
          object-fit: cover;
        }
      }

      .tooltip-icon {
        position: relative;
        display: inline-block;
        cursor: pointer;

        .tooltiptext-icon {
          display: none;
          width: fit-content;
          background-color: lightgrey;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          position: absolute;
          z-index: 1;
          bottom: 120%;
          left: 50%;
          transform: translateX(-50%);
          font-size: .8rem;
          font-weight: 400;
          transition: opacity 0s linear .5s;
          opacity: 0;

          &::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: lightgrey transparent transparent transparent;
          }
        }

        &:hover {
          .tooltiptext-icon {
            display: block;
            opacity: 1;
          }
        }
      }
    }
  }

  .function-buttons {
    display: inline-block;
    padding: .25rem;
    position: sticky;
    border-radius: 50rem;
    top: globalSharedVariables.$navbar-height;
    z-index: 20;

    button {
      width: 200px;
      font-size: 1rem;
    }
  }

  .input-table {
    border-spacing: 0;
    border-collapse: separate;
    
    tbody {
      margin-top: 10px;
    }

    tr > td:first-child {
      text-align: right;
    }

    input[type="date"], .ageGroup {
      width: fit-content;
      padding: 0 1rem;
      cursor: pointer;
    }

    td, th {
      padding: 5px;
    }

    th {
      text-align: center;
      width: 100%;
    }
  }

  .tooltip-searchDate {
    position: relative;
    display: inline-block;

    .tooltiptext-searchDate {
      display: none;
      width: fit-content;
      background-color: white;
      text-align: center;
      border-radius: 6px;
      padding: 5px;
      position: absolute;
      z-index: 1;
      bottom: 150%;
      left: 50%;
      transform: translateX(-100%);
      font-size: .8rem;
      font-weight: 400;
    }

    &:hover .tooltiptext-searchDate {
      display: block;
    }

    .tooltip-table {
      td {
        border: solid black 1px;
      }
    }
  }

  #preview-content-container {
    padding: .25rem;
    border: solid 2px globalSharedVariables.$orange-1;

    #control-box-specialist {
      display: grid;
      grid-template-columns: 1fr 4fr 1fr;
      $navigation_text_font_size: .6rem;
      $specialist_buttons_font_size: 5px;
      $info_font_size: .8rem;

      .icons-grid {
        display: grid;
        grid-template-columns: repeat(11, 1fr);
        grid-column: 1 / span 3;
        font-size: $navigation_text_font_size;
      }

      .preview-info {
        font-size: $info_font_size;
      }

      .prev-ques-nav-buttons {
        width: 30px;
      }

      .preview-icon-container {
        text-align: center;
      }

      .preview-icons {
        width: 50px;
        height: 24px;
      }

      .circle-button {
        width: 4 * $navigation_text_font_size;
        height: 4 * $navigation_text_font_size;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .green-button {
        box-shadow: inset 0 0 2px 2px #2B870B;
        color: #2B870B;
        border: 1px solid black;
        -webkit-text-stroke: 1px black;
      }

      .yellow-button {
        box-shadow: inset 0 0 2px 2px #FAFD5F;
        color: #FAFD5F;
        border: 1px solid black;
        -webkit-text-stroke: 1px black;
      }

      .red-button {
        box-shadow: inset 0 0 2px 2px #C40000;
        color: #C40000;
        border: 1px solid black;
        -webkit-text-stroke: 1px black;
      }

      .typicalDuration {
        border: solid #FAFD5F 2px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .timeOut {
        border: solid #2B870B 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .totalDuration {
        border: solid black 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .border-color-primary {
        border: solid 2px globalSharedVariables.$orange-1;
        margin: .25rem;
      }

      .exampleButton {
        border: solid black 1px;
        margin-bottom: 5px;
        border-radius: 50rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }


</style>